function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
export class ModalResolver extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderChildElement", source => {
      return /*#__PURE__*/React.cloneElement(source, {
        style: [source.props.style, this.props.style]
      });
    });

    _defineProperty(this, "renderComponentChildren", source => {
      return React.Children.map(source, this.renderChildElement);
    });

    _defineProperty(this, "renderComponent", () => {
      const componentChildren = this.renderComponentChildren(this.props.children);
      return /*#__PURE__*/React.createElement(View, {
        style: StyleSheet.absoluteFill
      }, /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: [StyleSheet.absoluteFill, this.props.backdropStyle],
        activeOpacity: 1.0,
        onPress: this.props.onBackdropPress
      }), componentChildren);
    });
  }

  render() {
    return this.props.visible && this.renderComponent();
  }

}

_defineProperty(ModalResolver, "defaultProps", {
  visible: false
});